export function roundToSigns(a, s=0, strOrNum=true){
    try {return strOrNum ? Number(a.toFixed(s)) : a.toFixed(s);} catch(e) {return a;}
}

export function getScoreMass({estimates, coeffs}, sings=2) {
    let scoreMass = [];
    for (let i = 0; i < estimates.length; i++) {
        let currEst = estimates.slice(0, i+1), currCoeffs = coeffs.slice(0, i+1)
        scoreMass.push(roundToSigns(countMean({estimates: currEst, coeffs: currCoeffs}), sings));
    }
    return scoreMass;
}

function findClosestIndex(dates, n, today) {
    today.setHours(0, 0, 0, 0);

    let target = new Date(today);
    target.setDate(today.getDate() - n);
    if (isNaN(target.getDate())) target = new Date(-8640000000000000)

    // преобразуем массив в объекты Date
    const parsedDates = dates.map(d => {
        const [day, month, year] = d.split(".").map(Number);
        return new Date(year, month - 1, day);
    });

    // ищем ближайший индекс
    let index = parsedDates.findIndex(d => d >= target && d <= today);

    // если ничего не нашли, можно вернуть -1
    return index !== -1 ? Math.max(0, index) : index;
}

export function heatMapData(allMarks, days, today) {
    const data = {};
    const subjects = Object.keys(allMarks);
    for (let subj of subjects) {
        const index = findClosestIndex(allMarks[subj].dates, days, today);
        if (index === -1) {data[subj] = 0; continue}
        const scores = getScoreMass({estimates: allMarks[subj].estimates, coeffs: allMarks[subj].coeffs});
        data[subj] = roundToSigns(scores[scores.length - 1] - scores[Math.max(0, index-1)] || 0, 2);
    }
    return data;
}

export function pieChartData(allMarks, days, today) {
    const counts = [0, 0, 0, 0, 0];
    for (let subj in allMarks) {
        const info = allMarks[subj];
        const index = findClosestIndex(info.dates, days, today)
        if (index === -1) continue;
        for (let est of info.estimates.slice(index)) {
            counts[5-est]++;
        }
    }
    return counts;
}

export function nameShorter(name, rectWidth) {
    if (!name) return "";
    const chars = rectWidth / 8;
    if (rectWidth < 1) return name;
    if (name.length > chars) return `${name.slice(0, chars-2)}...`;
    return name;
}

export function countYearMeans(allInfo) {
    const subjects = Object.keys(allInfo[Object.keys(allInfo)[0]].currMarks);
    const means = [];
    for (let index = 0; index < subjects.length; index++) {
        const rounds = [];
        for (let key in allInfo) {
            if (key.toLowerCase() === "год") {
                let sum = 0;
                let len = 0;
                for (let r of rounds) {
                    if (r !== 0) {
                        sum += r;
                        len += 1;
                    }
                }
                const mean = roundToSigns(len !== 0 ? sum/len : 0)
                means.push(mean);
            } else {
                const mean = allInfo[key].means[index].mean
                rounds.push(roundToSigns(Number(mean)))
            }
        }
    }
    return means;
}

export function count(arr, val) {
    return arr.filter(a => a === val).length;
}

export function getColorClass(mean) {
    mean = Number(mean);
    const min = {5: "five", 4: "four", 3: "three", 2: "two", 1: "one"}[mean];
    return min || "no-estimates";
}

function countMean({estimates, coeffs}) {
    let sumE = 0, sumC = 0;
    for (let i = 0;  i < estimates.length; i++) {
        let e = estimates[i]*coeffs[i]
        sumE += e;
        sumC += coeffs[i];
    }
    if (sumE <= 0 || sumC <= 0) return 0;
    return sumE / sumC;
}

function parseDate(dateStr) {
    const [day, month, year] = dateStr.split('.').map(Number);
    return new Date(year, month - 1, day);
}

export function autoGetPer(boundaryDates) {
    const now = Date.now();
    for (let i = 0; i < boundaryDates.length; i++) {
        const currentDate = parseDate(boundaryDates[i].date);
        if (i === 0 && now < currentDate) return 1;
        else if (i === boundaryDates.length-1 && now > currentDate) return boundaryDates.length+1;
        else if (now < currentDate && now > parseDate(boundaryDates[i-1].date)) return i+1;
    }
}

export function subjInfo(info) {
    if (!info) return null;
    const mean = countMean(info)
    const nowScore = roundToSigns(mean, 8, false)
    const score2Signs = roundToSigns(mean, 2, false)
    const round = roundToSigns(Number(score2Signs))
    const scoreMass = getScoreMass(info, 10);
    return {
        info,
        scoreMass,
        nowScore,
        score2Signs,
        round,
        color: getColorClass(round),
        min: {
            min: Math.min(...scoreMass),
            color: getColorClass(roundToSigns(roundToSigns(Math.min(...scoreMass), 2)))
        },
        max: {
            max: Math.max(...scoreMass),
            color: getColorClass(roundToSigns(roundToSigns(Math.max(...scoreMass), 2)))
        }
    };
}

const XLSX = require("xlsx");
const url = process.env.REACT_APP_FILES_URL;
export async function getSheet(fileName, sheetIndex = 0) {
    const response = await fetch(`${url}/files/${fileName}`);
    if (!response || !response.ok) {
        throw new Error(`Не удалось загрузить файл ${fileName}`);
    }

    const arrayBuffer = await response.arrayBuffer();

    const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: "array" });
    if (!workbook) return null;
    const sheetName = workbook.SheetNames[sheetIndex];
    return workbook.Sheets[sheetName];
}

export const coeffs = {
    "Административная контрольная работа": 1.5, "Аудирование": 1.4,
    "Ведение тетради": 1, "Дистанционное занятие": 1,
    "Дифференцированный зачет": 1, "Домашнее задание": 1,
    "Домашнее сочинение": 1.4, "Зачёт": 1.5,
    "Изложение": 1.4, "Инструктаж": 1,
    "Квалификационное испытание": 1, "Классное сочинение": 1.5,
    "Контрольная практическая работа": 1.5,
    "Контрольная работа": 1.5, "Контрольный диктант": 1.5,
    "Курсовая работа": 1, "Лабораторная работа": 1.3,
    "Практическая работа": 1.3, "Проверочная работа": 1.3,
    "Проект": 1, "Работа на занятии": 1, "Работа на уроке": 1,
    "Работа над ошибками": 1, "Самостоятельная работа": 1.2,
    "Словарный диктант": 1.4, "Сочинение": 1,
    "Срезовая работа": 1.3, "Тест": 1,
    "Чтение наизусть": 1, "Электронное обучение": 1,
}